module.exports = __webpack_public_path__ + "img/icon14.029dd86c.png";